import { ReduxState, themes } from 'kb-shared';
import React, { ReactNode } from 'react';
import Loader from 'react-loading';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps, withRouter } from 'react-router-dom';

import { AbsoluteCentered } from '../styled';
import { checkAndSetConsent } from '../utilities/consent';

type Props = RouteComponentProps & {
  landingPage: 'login' | 'signup';
  authCheckInProgress: boolean;
  children: ReactNode;
  isLoggedIn: boolean;
  loginUrl?: string;
};

class ProtectedRoute extends React.Component<Props> {
  _redirected = false;

  componentDidMount() {
    this.checkForConsent();
  }

  checkForConsent() {
    const consent = checkAndSetConsent();
    if (consent) {
      this.redirectToConsent(consent);
    }
  }

  redirectToConsent(consent: string) {
    if (this._redirected || window.location.href.includes('/consents/')) return;
    this._redirected = true;
    this.props.history.replace(`/consents/${consent}`);
  }

  render() {
    const {
      authCheckInProgress,
      children,
      isLoggedIn,
      landingPage = 'login',
      loginUrl
    } = this.props;

    if (!authCheckInProgress && !isLoggedIn) {
      const location = window.location;
      const returnUrl =
        location.pathname === '/' ? null : encodeURIComponent(location.pathname + location.search);

      if (
        (location.pathname === '/book' && location.search.includes('membership_id')) ||
        location.search.includes('enterprise_membership')
      ) {
        if (returnUrl) {
          return <Redirect to={`/create-account?step=create_account&target=${returnUrl}`} />;
        }
        return <Redirect to={`/create-account`} />;
      }

      if (landingPage === 'login') {
        if (loginUrl) {
          window.location.href = loginUrl;
          return;
        }
        if (returnUrl) {
          return <Redirect to={`/login?target=${returnUrl}`} />;
        } else {
          return <Redirect to={`/login`} />;
        }
      } else {
        return <Redirect to={`/create-account?step=create_account&target=${returnUrl}`} />;
      }
    }

    if (authCheckInProgress || !isLoggedIn) {
      return (
        <AbsoluteCentered>
          <Loader type="spin" color={themes.colors.KBYellow} height={150} width={150} />
        </AbsoluteCentered>
      );
    }

    return children;
  }
}

const mapStateToProps = ({
  patient: { isLoggedIn, authCheckInProgress, loginUrl }
}: ReduxState) => ({
  authCheckInProgress,
  isLoggedIn,
  loginUrl
});

const mapDispatchToProps = () => ({});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProtectedRoute));
